import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { PersonIdentifierViewModel } from '../../../models/Entities/Person/Identifier/PersonIdentifierModels';

// store
import * as PersonIdentifiersStore from '../../../redux/middleware/PersonIdentifiers.Middleware';

export interface IProps {
  isOpen: boolean;
  openPanel: () => void;
  dismissPanel: () => void;
  PersonId: number;
  PersonType?: number | undefined;
  identifierId?: number | undefined;
}

interface ConnectedProps {
  isAdding: boolean | undefined;
  successAdding: boolean | undefined;
  failAdding: boolean | undefined;
  isUpdating: boolean | undefined;
  successUpdating: boolean | undefined;
  failUpdating: boolean | undefined;
  isVerifying: boolean | undefined;
  isIdentifierAvailable: boolean | undefined;
  error: ErrorType | undefined;
  identifier?: PersonIdentifierViewModel;
}

interface DispatchProps {
  CreatePersonIdentifier: typeof PersonIdentifiersStore.actionCreators.CreatePersonIdentifier;
  UpdatePersonIdentifier: typeof PersonIdentifiersStore.actionCreators.UpdatePersonIdentifier;
  VerifyIdentifier: typeof PersonIdentifiersStore.actionCreators.VerifyIdentifier;
  ResetIdentifierVerification: typeof PersonIdentifiersStore.actionCreators.ResetIdentifierVerification;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isAdding: state.PersonIdentifiers?.isAddingNewOne,
  successAdding: state.PersonIdentifiers?.successAddingNewOne,
  failAdding: state.PersonIdentifiers?.failOnAddingNewOne,
  isUpdating: state.PersonIdentifiers?.isUpdatingOne,
  successUpdating: state.PersonIdentifiers?.successUpdatingOne,
  failUpdating: state.PersonIdentifiers?.failOnUpdatingOne,
  isVerifying: state.PersonIdentifiers?.isVerifying,
  isIdentifierAvailable: state.PersonIdentifiers?.isIdentifierAvailable,
  error: state.PersonIdentifiers?.error,
  identifier: state.PersonIdentifiers?.list.find(
    (item: PersonIdentifierViewModel) => item.id === ownProps.identifierId
  ),
  ...ownProps
});

export const mapDispatchToProps = {
  ...PersonIdentifiersStore.actionCreators
};
